import { render, staticRenderFns } from "./BillboardLink.vue?vue&type=template&id=bc024a70&scoped=true"
import script from "./BillboardLink.vue?vue&type=script&lang=js"
export * from "./BillboardLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc024a70",
  null
  
)

export default component.exports